export const ENTITLEMENTS_CONST = {
  clearEntitlementsCache: 'clearEntCache',
};
